<template>
  <b-container>
    <div class="py-5">
      <b-row align-h="center">
        <b-col cols="12" class="text-center">
          <b-img :src="hatImage" />
        </b-col>
        <b-col v-orphans cols="12" class="mt-3 text-center mb-4 font-responsive">
          <p class="h2 font-weight-bold font-italic">{{ $t('home.bottomSection.header') }}</p>
        </b-col>
        <b-row v-orphans no-gutters align-h="between">
          <b-col cols="12" md="5" class="mt-4">
            <p
              v-for="(item, index) in tm('home.bottomSection.indexDescription')"
              class="text-filter-label mx-3 mx-md-4"
              :key="index"
              v-html="rt(item.toString())"
            ></p>
          </b-col>
          <b-col cols="11" md="5" class="mt-4">
            <div class="mx-3 mx-md-4 mb-3 bottomSection-indexQuote font-responsive">
              <b-img :src="quoteImage" />
              <div class="quote font-italic mx-4">
                {{ $t('home.bottomSection.indexQuote') }}
              </div>
              <div class="font-weight-bold mx-4 mt-3">{{ $t('home.bottomSection.indexSign') }}</div>
            </div>
          </b-col>
        </b-row>
      </b-row>
    </div>
  </b-container>
</template>

<script setup lang="ts">
import { useSwdI18n } from '@/composables'

const { tm, rt } = useSwdI18n()
const hatImage = new URL('/src/assets/images/hat_icon.png', import.meta.url).href
const quoteImage = new URL('/src/assets/images/quote_icon.png', import.meta.url).href
</script>
